export interface Brand {
  brandId: string;
  name: string;
  slug?: string;
  description?: string;
  logoUrl?: string;
  brandAssetsLinks?: string[];
  productLinks?: string[];
  brandColors?: string[];
  websiteUrl?: string;
  // Logto organization id of the brand's Business Portal company.
  organizationId?: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
}

export interface BrandFilter {
  limit?: number;
  offset?: number;
}

export interface CreateBrandRequest {
  name: string;
  slug?: string;
  description?: string;
  logoUrl?: string;
  brandAssetsLinks?: string[];
  productLinks?: string[];
  brandColors?: string[];
  websiteUrl?: string;
  organizationId?: string;
}

export interface UpdateBrandRequest {
  name?: string;
  slug?: string;
  description?: string;
  logoUrl?: string;
  brandAssetsLinks?: string[];
  productLinks?: string[];
  brandColors?: string[];
  websiteUrl?: string;
  // null unlinks the brand from its Business Portal company.
  organizationId?: string | null;
}

export const DEFAULT_BRAND_LIST_LIMIT = 20;
export const MAX_BRAND_LIST_LIMIT = 100;

export const BRAND_ORGANIZATION_ID_MAX_LENGTH = 64;

export const BRAND_SLUG_PATTERN = /^[a-z0-9-]+$/;
export const BRAND_HEX_COLOR_PATTERN =
  /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;
